import { Grid, Stack } from "@mui/material";
import NomenclatureOrder from "../../../utils/homologar/nomenclatureOrder/NomenclatureOrder";
import { OrderType } from "../../../utils/homologar/search/utils/constants";

const HomologarOrders = ({ orders, setOrders, form, isV2, orderType, ...props }) => {
  const showEmptyState = isV2 && orderType === OrderType.PRACTICES && orders.length === 0;

  const onRemoveOrder = (index) => () =>
    setOrders((prev) => {
      const newOrders = [...prev];
      newOrders.splice(index, 1);
      return newOrders;
    });

  const onClarificationsChange = (index) => (value) => {
    setOrders((prev) => {
      const newPractices = [...prev];
      newPractices[index].clarifications = value;
      return newPractices;
    });
  };

  const onOrderItemRemove = (index) => (item) => {
    setOrders((prev) => {
      const newOrders = [...prev];
      newOrders[index].items = newOrders[index].items.filter(
        (i) => (i.procedureId ?? i.name) !== (item.procedureId ?? item.name)
      );
      if (newOrders[index].items.length === 0) {
        newOrders.splice(index, 1);
      }
      return newOrders;
    });
  };

  return (
    <Grid item xs={12} sm={12} md={12}>
      <Stack>
        <Grid container spacing={2} minHeight={260}>
          {!showEmptyState && orders.map((order, index) => (
            <NomenclatureOrder
              key={index}
              order={order}
              onRemove={onRemoveOrder(index)}
              onChange={onClarificationsChange(index)}
              onItemRemove={onOrderItemRemove(index)}
              form={form}
              enableRemoveButton={orders.length > 1}
              isV2={isV2}
              {...props}
            />
          ))}
        </Grid>
      </Stack>
    </Grid>
  );
};

export default HomologarOrders;
